<!--
  钱包模块
-->
<template>
  <div class='wallet-content-box'>
    <title-header title='我的钱包'></title-header>
    <!-- 已是分销员 -->
    <div class='wallet-content' v-if='isDistributor'>
      <!-- 总资产 -->
      <div class='total-assets-box'>
        <div class='assets-top'>
          <div>总资产（金豆）</div>
          <div @click='gotoBankCard' class='can-click'>我的银行卡</div>
        </div>
        <div class='beans-count'>{{beansNum}}</div>
        <div @click='gotoDetail' class='can-click'>查看明细</div>
        <self-button type='default' style='margin: 5px 0;' @click.native='showWithdraw'>提现</self-button>
      </div>
      <div style='margin: 10px 0;font-weight:bold;'>分销订单</div>
      <!-- 分销订单表头 -->
      <div class='settle-item settle-item-header' >
        <div class='goods-info'>
          <span class='overline'>商品名称</span>
          <span class='overline'>会员</span>
          <span>商品价格</span>
          <span class='overline'>分销</span>
        </div>
      </div>
      <div class='settle-item' v-for="(item, index) in orderList" :key='index'>
        <div class='goods-info'>
          <span class='overline'>{{item.goodsName}}</span>
          <span class='overline'>{{item.userName}}</span>
          <span>￥{{item.subTotalPrice | formatPrice}}</span>
          <span class='overline'>{{item.bean | formatBeans(item.distributionStatus)}}</span>
        </div>
        <div class='create-time'>{{item.createAt}}</div>
      </div>
      <van-pagination 
        style='margin-top:10px;'
        force-ellipses
        v-model="page.pageNumber" 
        :total-items="page.total" 
        :items-per-page="page.pageSize"
        @change='changePage'
      />
    </div>
    <!-- 不是分销员 -->
    <div class='no-distribution-content' v-else>
      <div class='no-distribution-tip'>对不起您还不是分销员，申请成为分销员即可开启赚钱之路。</div>
      <div class='button-box' @click="gotoApply">
        <van-button type="primary" color='#45C5DA'>立即申请成为分销员</van-button>
      </div>
    </div>
    <!-- 提现模态框 -->
    <van-dialog 
      v-model="display.showWithdraw" 
      show-cancel-button 
      :before-close='beforeCloseWithdraw'
    >
      <div class='withdraw-content clearfix'>
        <div class='selected-bank-box' @click='openSelectCard'>
          <span>{{cardName}}({{cardNum}})</span>
          <van-icon name="arrow" size='24' />
        </div>
        <van-field 
          label='输入金豆数'
          v-model="withdrawBeans" 
          style='margin: 10px 0;padding-right: 0;padding-left: 0;' 
          type="number" 
          placeholder='最低提现数量为10000豆' 
          size='large' 
        >
        </van-field>
        <div class='clearfix'>
          <span class='withdraw-tip'>100金豆 = 1元</span>
          <van-button class='all-thdraw-btn' size="small" type="primary" color='#45C5DA' @click='allWithdraw'>全部提现</van-button>  
        </div>
      </div>
    </van-dialog>
    <!-- 提现输入密码模态框 -->
    <van-dialog
      v-model="display.showPassword"
      show-cancel-button 
      :before-close='beforeClosePwd'
    >
      <div class='withdraw-content clearfix'>
        <div>输入支付密码</div>
        <van-password-input
          style='margin: 15px 0;'
          :value="withdrawPwd"
          @focus="display.showKeyboard = true"
        />
        <!-- <van-field v-model="withdrawPwd" type="password" placeholder='请输入提现密码' size='large' /> -->
      </div>
    </van-dialog>
    <!-- 数字键盘 -->
    <van-number-keyboard
      v-model="withdrawPwd"
      :show="display.showKeyboard"
      :maxlength="6"
      @blur="display.showKeyboard = false"
    />
    <!-- 未设置支付密码提示框 -->
    <van-dialog
      v-model="display.noSetPwd"
      title='请前往个人中心-账号安全 设置支付密码'
      confirmButtonText='立即前往'
      show-cancel-button 
      @confirm='gotoSetPwd'
    >
      <div class='withdraw-content clearfix'>
      </div>
    </van-dialog>
    
    <!-- 未设置银行卡提示框 -->
    <van-dialog
      v-model="display.noSetBankCard"
      title='请先绑定银行卡'
      confirmButtonText='立即前往'
      show-cancel-button 
      @confirm='gotoBankCard'
    >
      <div class='withdraw-content clearfix'>
      </div>
    </van-dialog>
    <!-- 银行卡选择框 -->
    <van-action-sheet 
      title='选择银行卡'
      :overlay='false' 
      v-model="display.selectCard" 
      @select="onSelectCard"
    >
      <div class='bank-card-box'>
        <div v-for='(item, index) in bankCardList' :key='index' class='bank-card-item' @click='selectBankCard(index)'>
          <div>{{item.bankName}}({{item.cardNo.slice(-4)}})</div>
          <van-icon name="success" size='20' v-show='selectedCardIndex == index' />
        </div>
      </div>
    </van-action-sheet>
    <van-loading class="data-loading" color="#45C5DA" v-show="display.showLoading" />
  </div>
</template>

<script>
  import walletApi from 'api/wallet';
  import { Toast } from 'vant';
  export default {
    data() {
      return {
        display: {
          showWithdraw: false,
          showPassword: false,
          noSetPwd: false,//未设置支付密码
          noSetBankCard: false, //未绑定银行卡
          selectCard: false, //选择银行卡框
          showKeyboard: false,
          showLoading: false,//页面加载
        },
        page: {
          pageSize: 6,
          pageNumber: 1,
          total: 0
        },
        withdrawBeans: '',//提现金额
        beansNum: 0, //豆子数量
        withdrawPwd: '',
        orderList: [], //分销订单列表
        bankCardList: [], //银行卡列表
        selectedCardIndex: 0, //默认选择第一张银行卡
      }
    },
    computed:{
      isDistributor() { //是否为分销员
        return this.$store.state.userInfo.isDistributor == 1;
      },
      cardName() { //银行卡名称
        return this.bankCardList[this.selectedCardIndex]?this.bankCardList[this.selectedCardIndex].bankName:'';
      },
      cardNum() {
        return this.bankCardList[this.selectedCardIndex]?this.bankCardList[this.selectedCardIndex].cardNo.slice(-4):'';
      }
    },
    created() {
      this.getMyDistributeOrders()
      this.getBankCard()
    },
    methods: {
      gotoDetail() {
        this.$router.push({
          name:'walletDetail'
        })
      },
      //前往我的银行卡
      gotoBankCard() {
        this.$router.push({
          name: 'bankCard'
        })
      },
      //前往申请分销员
      gotoApply() {
        this.$router.push({
          name: 'applyDistributor'
        })
      },
      //前往设置支付密码
      gotoSetPwd() {
        this.$router.push({
          name: 'payPwd'
        })
      },
      //获取分销订单详情
      async getMyDistributeOrders() {
        this.display.showLoading = true;
        const data = await walletApi.getMyDistributeOrders({
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber
        })
        this.display.showLoading = false;
        this.page.total = data.walletGoodsVoPage.total;
        this.orderList = data.walletGoodsVoPage ? data.walletGoodsVoPage.records : [];
        this.beansNum = data.totalBean;
      },
      //加载
      changePage() {
        this.getMyDistributeOrders()
      },
      //获取银行卡列表
      getBankCard() {
        walletApi.getBankCardList()
          .then(res => {
            this.bankCardList = res ? res : [];
          })
      },
      //打开提现模态框
      showWithdraw() {
        if( this.$store.state.userInfo.hasPayPwd === 1) { //没有设置支付密码
          this.display.noSetPwd = true;
          return
        }
        //没有绑定银行卡
        if (this.bankCardList.length === 0) {
          this.display.noSetBankCard = true;
          return
        }
        if(this.beansNum < 10000) {
          Toast('最低提现额度为10000豆')
          return
        }
        this.withdrawBeans = '';
        this.display.showWithdraw = true
      },
      //检测输入是否符合规则,提现
      beforeCloseWithdraw(action, done) {
        if(action === 'confirm') {
          if(this.withdrawBeans < 10000) {
            Toast('最低提现额度为10000')
            done(false)
            return
          }
          if(this.withdrawBeans > this.beansNum) {
            Toast('余额不足')
            done(false)
            return
          }
          this.display.showPassword = true;
          this.display.showKeyboard = true
          this.withdrawPwd = '';
        }
        done(true)
        this.display.selectCard = false;//关闭银行卡选择
      },
      //点击全部提现
      allWithdraw() {
        this.withdrawBeans = this.beansNum;
      },
      //校验提现密码
      beforeClosePwd(action, done) {
        if(action === 'confirm') {
          if(this.withdrawPwd.length < 6) {
            Toast('密码错误')
            done(false)
            return
          }
          const params = {
            payPwd: this.withdrawPwd,
            amount: Number(this.withdrawBeans),
            cardNo: this.bankCardList[this.selectedCardIndex].cardNo,
            bankId: this.bankCardList[this.selectedCardIndex].bankId
          }
          this.display.showKeyboard = false;
          walletApi.applyWithdraw(params)
            .then(res => {
              done(true)
              this.getMyDistributeOrders()
              Toast.success('提现申请已提交')
            })
            .catch(res => {
              done(false)
              Toast(res.message)
            })
        }else{
          done(true)
          this.display.showKeyboard = false;
        }
      },
      //打开银行卡选择框
      openSelectCard() {
        this.display.selectCard = true;
      },
      //选择银行卡
      selectBankCard(index) {
        this.selectedCardIndex = index;
        this.display.selectCard = false;
      },
      //选择银行卡
      onSelectCard() {

      },
      closeWithdraw() {
        this.display.showWithdraw = false;
      }
    },
    filters: {
      formatBeans(val,distributionStatus) {
        if(distributionStatus === 1) { //未分销
          return '未分成'
        }else {
          return val + '金豆';
        }
      }
    }
  }
</script>

<style lang='scss'>
  @import 'common/sass/theme.scss';
  .overlay-class{
    border: 1px solid #ddd;
    
  }
  .withdraw-content .van-password-input{
    margin: 0;   
  }
  .wallet-content-box .van-number-keyboard{
    z-index: 9999;
  }
  .wallet-content-box .van-pagination__item{
    color: $theme-color;
  }
  .wallet-content-box .van-pagination__item--active{
    background-color: $theme-color;
    color: #fff;
  }
</style>
<style lang="scss" scoped>
  @import 'common/sass/theme.scss';
  .wallet-content{
    padding: 15px;
    .total-assets-box{
      padding: 15px;
      box-shadow: 0 1px 6px rgba(0,0,0,.2);
      border-radius: 10px;
      .assets-top{
        display: flex;
        justify-content: space-between;
      }
      .beans-count{
        margin: 5px 0;
        font-weight: bold;
        font-size: 18px;
      }
      .can-click{
        color: $theme-color
      }
    }
    .settle-item{
      border-bottom: 1px solid $light-color;
      .goods-info{
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
        span{
          width: 25%;
          text-align: center;
        }
      }
      .create-time{
        margin-bottom: 5px;
        color: $lingt-word-color;
        font-size: 13px;
      }
    }
    .settle-item-header{
      background-color: #f8f8f9;
      border-bottom: 1px solid #eaeaea;
      padding: 4px 0;
      font-size: 14px;
      .goods-info{
        margin: 5px 0;
      }
    }


  }
  
  .no-distribution-content{
    .no-distribution-tip{
      margin: 50px 20px;
    }
    .button-box{
      text-align: center;
    }
  }
  .withdraw-content{
    padding: 15px 15px 30px;
    .all-withdraw-btn{
      float: right;
      margin: 5px 0;
      color: $theme-color;
    }
    .withdraw-tip{
      float: left;
      font-size: 12px;
      color: $red-color;
    }
    .all-thdraw-btn{
      float: right;
    }
    .selected-bank-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #ebedf0;
    }
  }
  .bank-card-box{
    min-height: 150px;  
    border-top: 1px solid #ebedf0;
    .bank-card-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid #ebedf0;
    }
  }
</style>